import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalRolesCards } from 'widgets/roles-modal/ui/ModalRolesCards/ModalRolesCards';

import { MpLink } from 'shared/ui/MpLink';
import {
	InternalAccountModalStyled,
	ModalHeadingStyled,
	ModalSmallHeadingStyled,
	ModalSubheadingStyled,
	ModalTextStyled,
} from './InternalAccountModal.styles';

export const InternalAccountModal: FC = () => {
	const { t } = useTranslation();

	return (
		<InternalAccountModalStyled>
			<ModalHeadingStyled>{t(`Marketplace_No_Connection_Access`)}</ModalHeadingStyled>
			<ModalTextStyled size={14}>{t(`Marketplace_Excluded_Account_Type`)}</ModalTextStyled>
			<ModalSmallHeadingStyled>{t(`Marketplace_No_Limited_Access_Account`)}</ModalSmallHeadingStyled>
			<ModalTextStyled size={14}>
				{t(`Marketplace_Fill_Pyrus_Request_1`)}
				<MpLink url='https://pyrus.com/t#uf714369' text={t(`Marketplace_Pyrus_Request`)} />
				{t(`Marketplace_Fill_Pyrus_Request_2`)}
			</ModalTextStyled>
			<ModalSubheadingStyled>{t(`Marketplace_Role_Access`)}</ModalSubheadingStyled>
			<ModalRolesCards />
		</InternalAccountModalStyled>
	);
};
